import { useEffect, useRef, useState } from "react";
import { formatDateForChat } from "../../_helper";
import SendReplyFromAdminToPartner from "./SendReplyFromAdminToPartner";
import { getRepliesForAdmin } from "../../apis";
import EditReplyForAdmin from "./EditReplyForAdmin";
import DeleteReplyForAdmin from "./DeleteReplyForAdmin";
import InfiniteScroll from "react-infinite-scroll-component";
import useReplies from "./useReplies";
import SeenIcons from "../Svgs/SeenIcons";

const AdminMessageChat = ({ mainMessageData, currentMessageId }) => {
  const {
    scrollRef,
    repliesData,
    pagination,
    isLoading,
    fetchReplies,
    setRepliesData,
    setPagination,
    setIsLoading,
  } = useReplies();

  const dropdownRef = useRef(null);
  const topScrollMarker = useRef();

  const isIncomingMessage = mainMessageData.messageCategory === "In";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenForEdit, setIsModalOpenForEdit] = useState(false);
  const [currentEditReplyId, setCurrentEditReplyId] = useState("");
  const [modalImage, setModalImage] = useState(null);
  const [dropdownIndex, setDropdownIndex] = useState(null);

  const handleImageClick = (url) => {
    setModalImage(url);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setModalImage(null);
    setIsModalOpen(false);
  };

  const toggleDropdown = (index) => {
    setDropdownIndex(dropdownIndex === index ? null : index);
  };

  useEffect(() => {
    fetchReplies({ messageId: currentMessageId, scrollToBottom: true });
  }, [currentMessageId]);

  const loadMoreReplies = async () => {
    if (pagination.current_page >= pagination.last_page) return;

    setIsLoading(true);
    try {
      const scroll = scrollRef.current;
      const previousScrollHeight = scroll.scrollHeight;

      const nextPage = pagination.current_page + 1;
      const response = await getRepliesForAdmin(currentMessageId, nextPage);

      const newReplies = response.data.data.reverse();
      setRepliesData((prev) => [...newReplies, ...prev]);
      setPagination({
        current_page: response.data.meta.current_page,
        last_page: response.data.meta.last_page,
      });

      setTimeout(() => {
        const newScrollHeight = scroll.scrollHeight;
        scroll.scrollTop =
          newScrollHeight - previousScrollHeight + scroll.scrollTop;
      }, 50);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        id="scrollableReplies"
        ref={scrollRef}
        style={{
          overflow: "auto",
          display: "flex",
          flexDirection: "column-reverse",
        }}
        className="max-xl:!tw-pb-12 tw-h-[71vh]  tw-bg-gradient-to-r tw-p-4 tw-overflow-y-auto tw-from-gray-100 tw-to-gray-200"
      >
        <div ref={topScrollMarker}></div>

        {/* Replies */}
        <InfiniteScroll
          dataLength={repliesData.length}
          next={loadMoreReplies}
          hasMore={pagination.current_page < pagination.last_page}
          loader={
            <p className="tw-text-center tw-text-gray-400 tw-absolute tw-top-20 tw-left-1/2 tw--translate-x-1/2">
              Loading more...
            </p>
          }
          scrollableTarget="scrollableReplies"
          inverse={true}
        >
          {/* Main Message */}
          {!isLoading && pagination.current_page >= pagination.last_page && (
            <div>
              {isIncomingMessage ? (
                <div className="tw-flex tw-items-end tw-mb-6">
                  <div className="tw-w-9 tw-h-9 tw-rounded-full tw-mr-2">
                    <img
                      src={mainMessageData?.userImage}
                      alt="Sender"
                      className="tw-w-9 tw-h-9 tw-rounded-full"
                    />
                  </div>
                  <div className="tw-min-w-24 tw-relative tw-max-w-[75%] tw-bg-white tw-rounded-lg tw-px-3 tw-py-2 tw-text-gray-700 tw-shadow">
                    <h4 className="tw-font-semibold !tw-mb-2 !tw-text-gray-700">
                      {mainMessageData?.messageTitle}
                    </h4>
                    <p className="tw-mb-4">{mainMessageData?.messageDetails}</p>

                    {mainMessageData?.messageImage && (
                      <img
                        src={mainMessageData.messageImage}
                        alt="attachment"
                        onClick={() =>
                          handleImageClick(mainMessageData.messageImage)
                        }
                        className="tw-mb-4 tw-rounded-lg tw-cursor-pointer tw-max-w-full tw-max-h-60 hover:tw-opacity-90 tw-transition"
                      />
                    )}

                    <span className="tw-absolute tw-bottom-1 tw-right-2 tw-text-[11px] tw-text-gray-400">
                      {formatDateForChat(mainMessageData?.createdAt)}
                    </span>

                    <div className="tw-absolute tw-left-[-8px] tw-bottom-2 tw-w-0 tw-h-0 tw-border-t-8 tw-border-t-transparent tw-border-b-8 tw-border-b-transparent tw-border-r-8 tw-border-r-white"></div>
                  </div>
                </div>
              ) : (
                <div className="tw-flex tw-items-end tw-justify-end tw-mb-6">
                  <div className="tw-min-w-24 tw-relative tw-max-w-[75%] tw-bg-secondary tw-text-white tw-rounded-lg tw-px-3 tw-py-2 tw-shadow">
                    <h4 className="tw-font-semibold !tw-mb-2 !tw-text-white">
                      {mainMessageData?.messageTitle}
                    </h4>
                    <p className="tw-mb-4">{mainMessageData?.messageDetails}</p>

                    {mainMessageData?.messageImage && (
                      <img
                        src={mainMessageData.messageImage}
                        alt="attachment"
                        onClick={() =>
                          handleImageClick(mainMessageData.messageImage)
                        }
                        className="tw-mb-4 tw-rounded-lg tw-cursor-pointer tw-max-w-full tw-max-h-60 hover:tw-opacity-90 tw-transition"
                      />
                    )}

                    <span className="tw-absolute tw-bottom-1 tw-right-2 tw-text-[11px] tw-text-gray-200">
                      {formatDateForChat(mainMessageData?.createdAt)}
                    </span>

                    <div className="tw-absolute tw-right-[-8px] tw-bottom-2 tw-w-0 tw-h-0 tw-border-t-8 tw-border-t-transparent tw-border-b-8 tw-border-b-transparent tw-border-l-8 tw-border-l-secondary"></div>
                  </div>
                  <div className="tw-w-9 tw-h-9 tw-rounded-full tw-ml-2">
                    <img
                      src={mainMessageData?.userImage}
                      alt="Sender"
                      className="tw-w-9 tw-h-9 tw-rounded-full"
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          {repliesData.map((r, index) =>
            !r.isMyReply ? (
              <div key={index} className="tw-flex tw-items-end tw-mb-4">
                <div className="tw-w-9 tw-h-9 tw-rounded-full tw-mr-2">
                  <img
                    src={r?.userImage}
                    alt="User"
                    className="tw-w-9 tw-h-9 tw-rounded-full"
                  />
                </div>
                <div className="tw-min-w-24 tw-relative tw-max-w-[75%] tw-bg-white tw-rounded-lg tw-px-2 tw-py-2 tw-text-gray-700 tw-shadow">
                  <p className="tw-mb-2">{r?.message}</p>

                  {r?.messageAttache && (
                    <img
                      src={r.messageAttache}
                      alt="attachment"
                      onClick={() => handleImageClick(r.messageAttache)}
                      className="tw-mb-4 tw-rounded-lg tw-cursor-pointer tw-max-w-full tw-max-h-60 hover:tw-opacity-90 tw-transition"
                    />
                  )}
                  <span className="tw-bottom-1 tw-right-2 tw-text-[11px] tw-text-gray-400 tw-text-nowrap">
                    {r.createdAt}
                  </span>
                  <div className="tw-absolute tw-left-[-8px] tw-bottom-2 tw-w-0 tw-h-0 tw-border-t-8 tw-border-t-transparent tw-border-b-8 tw-border-b-transparent tw-border-r-8 tw-border-r-white"></div>
                </div>
              </div>
            ) : (
              <div
                key={index}
                className="tw-flex tw-items-end tw-justify-end tw-mb-4 tw-relative"
              >
                <div className="tw-min-w-24 tw-relative tw-max-w-[75%] tw-bg-secondary tw-text-white tw-rounded-lg tw-px-3 tw-py-2 tw-shadow">
                  <p className="tw-mb-2">{r?.message}</p>
                  {r?.messageAttache && (
                    <img
                      src={r.messageAttache}
                      alt="attachment"
                      onClick={() => handleImageClick(r.messageAttache)}
                      className="tw-mb-4 tw-rounded-lg tw-cursor-pointer tw-max-w-full tw-max-h-60 hover:tw-opacity-90 tw-transition"
                    />
                  )}
                  <span className="tw-absolute tw-flex tw-items-center tw-bottom-1 tw-right-2">
                    {r?.isSeen ? <SeenIcons fill="white" /> : ""}
                  </span>
                  <span className="tw-text-[11px] tw-text-gray-200 tw-inline-block tw-me-5 tw-text-nowrap">
                    {r.createdAt}
                  </span>
                  <div className="tw-absolute tw-right-[-8px] tw-bottom-2 tw-w-0 tw-h-0 tw-border-t-8 tw-border-t-transparent tw-border-b-8 tw-border-b-transparent tw-border-l-8 tw-border-l-secondary"></div>
                  {!r.isSeen && (
                    <div className="tw-absolute tw-top-1 tw-right-0 tw-z-30 tw-select-none">
                      <div
                        className="tw-cursor-pointer material-icons"
                        onClick={() => toggleDropdown(index)}
                      >
                        arrow_drop_down
                      </div>
                      {currentEditReplyId === r.id && (
                        <EditReplyForAdmin
                          replyData={r}
                          currentMessageId={currentMessageId}
                          setDropdownIndex={setDropdownIndex}
                          setIsModalOpenForEdit={setIsModalOpenForEdit}
                          isModalOpenForEdit={isModalOpenForEdit}
                          setRepliesData={setRepliesData}
                          setPagination={setPagination}
                        />
                      )}
                      {dropdownIndex === index && (
                        <div
                          ref={dropdownRef}
                          className="tw-absolute -tw-top-2 tw-right-5 tw-bg-white tw-rounded-md tw-shadow-md tw-z-50 tw-text-black tw-text-sm tw-w-24 tw-py-1"
                        >
                          <button
                            className="tw-w-full tw-text-left tw-px-3 tw-py-1 hover:tw-bg-gray-200"
                            onClick={() => {
                              setCurrentEditReplyId(r.id);
                              setIsModalOpenForEdit(true);
                            }}
                          >
                            Edit
                          </button>
                          <DeleteReplyForAdmin
                            currentMessageId={currentMessageId}
                            data={r}
                            setDropdownIndex={setDropdownIndex}
                            setRepliesData={setRepliesData}
                            setPagination={setPagination}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="tw-w-9 tw-h-9 tw-rounded-full tw-ml-2">
                  <img
                    src={r?.userImage}
                    alt="User"
                    className="tw-w-9 tw-h-9 tw-rounded-full"
                  />
                </div>
              </div>
            )
          )}
        </InfiniteScroll>

        {/* Image Modal */}
        {isModalOpen && (
          <div
            className="tw-fixed tw-inset-0 tw-bg-black/70 tw-flex tw-items-center tw-justify-center tw-z-50"
            onClick={closeModal}
          >
            <img
              src={modalImage}
              alt="preview"
              className="tw-max-w-[100%] tw-max-h-[80%] tw-rounded-lg tw-shadow-lg"
            />
          </div>
        )}
      </div>
      {/* Send New Reply */}
      <SendReplyFromAdminToPartner
        currentMessageId={currentMessageId}
        setRepliesData={setRepliesData}
        setPagination={setPagination}
      />
    </>
  );
};

export default AdminMessageChat;
